import React from 'react'
import { Box, Button } from '@mui/material';
import { FieldArray, Form, Formik } from "formik";
import { useSnackbar } from 'notistack';
import * as yup from "yup";
import { useDispatch, useSelector } from 'react-redux';
import * as fileApi from '../../../lib/api/file';
import { listPartnerfiles } from '../../../modules/partnerModule/files';
import ParMultiFileForm from '../../../components/partnermng/files/ParMultiFileForm';


const validationSchema = yup.object().shape({
    files: yup.array().of(
        yup.object().shape({
            fileAttrVal2: yup.string().required('파일 타입을 선택하세요'),
            fileDesc: yup.string().nullable('비고를 입력하세요'),
            file: yup.mixed().required('파일을 선택하세요'),
        })
    )
});

const getUploadErrorMessage = (err) => {
    const data = err?.response?.data;

    if (typeof data === 'string' && data.trim()) {
        return data;
    }

    return (
        data?.userMessage ||
        data?.message ||
        data?.error ||
        err?.message ||
        '거래처 파일 업로드에 실패했습니다.'
    );
};


const ParMultiFileFormContainer = () => {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { partner } = useSelector(({ partnerModule, loading }) => ({
        partner: partnerModule.partner.partner,
    }));

    const partnerUuid = partner?.partnerUuid;

    const onSave = async (value) => {
        let formData = new FormData();
        formData.append('fileDt', value.file);
        formData.append('fileTyp', 'partner');
        formData.append('fileAttrVal1', partnerUuid);
        formData.append('fileAttrVal2', value.fileAttrVal2);
        formData.append('fileDesc', value.fileDesc || '');
        //console.log(formData, 'formData');

        const response = await fileApi.addFiles(formData);
        if (response.data) {
            return response.data;
        }
    };

    return (
        <Box sx={{ my: 1 }}>


            <Formik
                initialValues={{
                    files: [{
                        fileAttrVal2: '',
                        fileDesc: '',
                        file: null
                    }]
                }}
                validationSchema={validationSchema}
                onSubmit={async (values, { resetForm, setSubmitting }) => {
                    if (!partnerUuid) {
                        enqueueSnackbar('거래처 기본정보를 먼저 저장한 뒤 증빙자료를 업로드하세요.', {
                            variant: 'error',
                        });
                        setSubmitting(false);
                        return;
                    }

                    try {
                        for (const value of values.files) {
                            await onSave(value);
                        }
                        dispatch(listPartnerfiles('partner', partnerUuid));
                        enqueueSnackbar('거래처 파일이 등록되었습니다.', {
                            variant: 'success',
                        });
                        resetForm();
                    } catch (err) {
                        enqueueSnackbar(getUploadErrorMessage(err), {
                            variant: 'error',
                        });
                    } finally {
                        setSubmitting(false);
                    }


                }}
            >
                {({ isSubmitting, values, touched, errors, handleChange, handleBlur, isValid }) => (
                    <Form noValidate autoComplete="off">
                        <FieldArray name="files">
                            {({ insert, remove, push }) => (
                                <Box>
                                    <Box>
                                        {values.files.map((f, index) => {
                                            return (
                                                <ParMultiFileForm
                                                    key={index}
                                                    file={f}
                                                    index={index}
                                                    touched={touched}
                                                    errors={errors}
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    handleRemove={() => remove(index)} />
                                            )
                                        })}
                                    </Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', my: 2 }}>
                                        <Button sx={{ mx: 2 }} color="secondary" variant="outlined" onClick={() => push({ fileAttrVal2: '', fileDesc: '', file: null })}>파일 추가</Button>
                                        <Button
                                            type="submit"
                                            color="primary"
                                            variant="contained"
                                            disabled={!partnerUuid || !isValid || values.files.length === 0 || isSubmitting}
                                        >
                                            저장
                                        </Button>
                                    </Box>
                                </Box>
                            )}
                        </FieldArray>

                    </Form>
                )}
            </Formik>

        </Box>
    )
}

export default ParMultiFileFormContainer
